import React from 'react';
import { DonutLegendChart } from '@/components/ui/DonutLegendChart';

export function ProjectDocsStats() {
  const statsData = [
    { name: 'Pháp lý', value: 16, color: '#a855f7' },
    { name: 'Thiết kế', value: 24, color: '#3b82f6' },
    { name: 'Thi công', value: 24, color: '#10b981' },
    { name: 'Nghiệm thu', value: 18, color: '#f97316' },
    { name: 'Báo cáo', value: 15, color: '#06b6d4' },
    { name: 'Hình ảnh', value: 12, color: '#eab308' },
  ];

  return (
    <div className="relative">
      <DonutLegendChart
        title="Thống kê tài liệu"
        centerValue={109}
        centerLabel="Tổng tài liệu"
        data={statsData}
        total={109}
      />
      <button className="absolute top-3 right-3 text-xs font-normal text-emerald-600 hover:underline">Xem chi tiết</button>
    </div>
  );
}
